import React from "react";
import NorwegianLanguagePack from './packs/no.json';
import EnglishLanguagePack from './packs/en.json';
import UkrainianLanguagePack from './packs/uk.json';

export enum Language {
  Norwegian = "no",
  English = "en",
  Ukrainian = "uk"
}

type LanguageContextProps = {
  currentLanguage: Language
  changeLanguage(lang: Language): void;
  languagePack: { [key: string]: any }
}

export const LanguageContext = React.createContext<LanguageContextProps>({ currentLanguage: Language.Norwegian, languagePack: {}, changeLanguage: () => { } });


export const LanguageProvider = ({ children }: any) => {
  const [currentLanguage, setCurrentLanguage] = React.useState(Language.Norwegian);
  const [languagePack, setLanguagePack] = React.useState<Object>(NorwegianLanguagePack);

  React.useEffect(() => {
    let languageToSet = null;
    switch (currentLanguage) {
      case Language.Norwegian:
        languageToSet = NorwegianLanguagePack;
        break;

      case Language.Ukrainian:
        languageToSet = UkrainianLanguagePack;
        break;

      case Language.English:
      default:
        languageToSet = EnglishLanguagePack;
        break;
    }
    setLanguagePack(languageToSet);
  }, [currentLanguage]);

  const changeLanguage = (lang: Language) => setCurrentLanguage(lang);

  return (
    <LanguageContext.Provider value={{ currentLanguage, languagePack, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useCurrentLanguage = () => {
  const { currentLanguage, changeLanguage } = React.useContext(LanguageContext);
  return { currentLanguage, changeLanguage };
}

export const useTranslation = () => {
  const { languagePack } = React.useContext(LanguageContext);

  const translate = React.useCallback((key: string, replacements?: any) => {
    if (!languagePack[key]?.length) {
      return key;
    }
    let ret = languagePack[key];

    if (replacements) {
      const replacementKeys = Object.keys(replacements);
      replacementKeys.forEach(replacementKey => {
        ret = ret.replace('{' + replacementKey + '}', replacements[replacementKey]);
      });
    }

    return ret;
  }, [languagePack]);

  return translate;
}